import { InfoCircleFilled } from "@ant-design/icons";

import styles from "./section-info-button.module.css";

export function SectionInfoButton({ onClick, ariaLabel }: { onClick: () => void; ariaLabel: string }) {
  return (
    <button type="button" className={styles.infoButton} onClick={onClick} aria-label={ariaLabel}>
      <InfoCircleFilled className={styles.infoIcon} />
    </button>
  );
}
